export const ForgotPasswordConstant = {
    ForgotPasswordValid: 'ForgotPasswordValid'
};

